import React, { Component } from "react";
import { Link } from "react-router-dom";
import data from "../Data/data";
export default class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemNumber: 1
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.num !== prevProps.num) {
      this.setState({ itemNumber: this.props.num });
    }
  }
  render() {
    const code = "</";
    return (
      <section className="intro_section" id="a">
        <div className="intro">
          <h1>
            <span>{code}</span>Hi, I am Himanshu
          </h1>
          <h2>Full Stack Developer</h2>
          <div className="action_button" mouse="true">
            <Link
              to="/contact"
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
            >
              Hire me
            </Link>
            <a
              href="/resume.pdf"
              id="resume"
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
              download
            >
              Resume
            </a>
          </div>
          <div className="snapshot_pagination">
            <h5>{this.state.itemNumber}</h5>
            <h5>-</h5>
            <h5>{data.length}</h5>
            <progress
              value={ (100 / data.length) * this.state.itemNumber}
              className="w3-pink"
              max="100"
            />
          </div>
        </div>
      </section>
    );
  }
}
